<div class="page-heading modal-content-header">
    <div class="layer-title">{{ header }}</div>
</div>

<div class="modal-content-body" [formGroup]="accessRightFormGroup">
    <div class="row">
        <div class="col-sm-6 col-lg-6 g-6">
            <div class="panel-row">
                <label for="clientName">Nom de l'entreprise (le cas échéant)</label>
                <ed-textfield
                    innerId="clientName"
                    type="text"
                    placeholder="Ex: Energies Demain"
                    [required]="false"
                    formControlName="clientName"></ed-textfield>
            </div>
        </div>

        <div class="col-sm-6 col-lg-6 g-6">
            <div class="panel-row">
                <label for="pdlNumber">Identifiant du PRM</label>
                <ed-textfield
                    innerId="pdlNumber"
                    type="text"
                    placeholder="Ex: 0123456789101"
                    [required]="true"
                    formControlName="pdlNumber"></ed-textfield>
            </div>
        </div>

        <div class="col-sm-6 col-lg-6 g-6">
            <div class="panel-row">
                <label for="clientSirenSiret">Numéro SIRET de l'entreprise (le cas échéant)</label>
                <ed-textfield
                    innerId="clientSirenSiret"
                    type="text"
                    placeholder="Ex: 48047850200077"
                    [required]="false"
                    formControlName="clientSirenSiret"></ed-textfield>
            </div>
        </div>

        <div class="col-sm-6 col-lg-6 g-6">
            <div class="panel-row">
                <label for="pdlPostalCode">Code postal du PRM</label>
                <ed-textfield
                    innerId="pdlPostalCode"
                    type="text"
                    placeholder="Ex: 56340"
                    [required]="false"
                    formControlName="pdlPostalCode"></ed-textfield>
            </div>
        </div>

        <div class="col-sm-6 col-lg-6 g-6">
            <div class="panel-row">
                <label for="consumptionAccessStart" required="true"
                    >Date de début de la récupération des données (2 ans d'historique
                    maximum)</label
                >
                <ed-datepicker
                    innerId="consumptionAccessStart"
                    placeholder="Ex: 03/03/2023"
                    (dateChange)="updateConsumptionAccessStart($event)"
                    [date]="accessRightFormGroup.get('consumptionAccessStart')?.value"
                    required></ed-datepicker>
            </div>
        </div>

        <div
            class="col-sm-6 col-lg-6 g-6"
            *ngIf="accessRightFormGroup.get('consentMethod')?.value === 'MAIL'">
            <div class="panel-row">
                <label for="clientRepresentativeName">Nom et prénom du representant légal</label>
                <ed-textfield
                    innerId="clientRepresentativeName"
                    type="text"
                    placeholder="Ex: Jean Martin"
                    [required]="true"
                    formControlName="clientRepresentativeName"></ed-textfield>
            </div>
        </div>

        <div class="col-sm-6 col-lg-6 g-6">
            <div class="panel-row">
                <label for="consentEnd">Date de fin de validité des droits (5 ans maximum)</label>
                <ed-datepicker
                    innerId="consentEnd"
                    type="date"
                    placeholder="Ex: 03/03/2025"
                    (dateChange)="updateConsentEnd($event)"
                    [date]="accessRightFormGroup.get('consentEnd')?.value"
                    required></ed-datepicker>
            </div>
        </div>

        <div
            class="col-sm-6 col-lg-6 g-6"
            *ngIf="accessRightFormGroup.get('consentMethod')?.value === 'MAIL'">
            <div class="panel-row">
                <label for="clientRepresentativeEmail"
                    >Email du représentant légal de l'entreprise
                </label>
                <ed-textfield
                    innerId="clientRepresentativeEmail"
                    type="text"
                    placeholder="Ex: prenom.nom@energies-demain.com"
                    [required]="true"
                    formControlName="clientRepresentativeEmail"></ed-textfield>
            </div>
        </div>

        <div class="col-sm-6 col-lg-6 g-6">
            <div class="panel-row">
                <label for="comments">Commentaire libre</label>
                <ed-textfield
                    innerId="comments"
                    type="text"
                    placeholder=""
                    [required]="false"
                    formControlName="comments"></ed-textfield>
            </div>
        </div>

        <div
            class="col-sm-6 col-lg-6 g-6"
            *ngIf="accessRightFormGroup.get('consentMethod')?.value === 'MAIL'">
            <div class="panel-row">
                <label for="clientRepresentativePhoneNumber"
                    >Numéro de téléphone du représentant légal</label
                >
                <ed-textfield
                    innerId="clientRepresentativePhoneNumber"
                    type="text"
                    placeholder="Ex: 01 44 16 03 40"
                    [required]="true"
                    formControlName="clientRepresentativePhoneNumber"></ed-textfield>
            </div>
        </div>
    </div>

    <div class="row">
        <div class="col-sm-6 col-lg-6">
            <div class="panel-row">
                <label for="grdfConsentMethod">Méthode de consentement</label>
                <ed-select
                    innerId="grdfConsentMethod"
                    placeholder="Sélectionner une méthode de consentement"
                    [options]="consentMethodOptions"
                    formControlName="consentMethod"></ed-select>

                <div
                    *ngIf="accessRightFormGroup.get('consentMethod')?.value === 'MAIL'"
                    class="label-info">
                    Vous {{loggedUser?.firstname}} {{loggedUser?.lastname}} autorisez Consometer - ENERGIES DEMAIN à demander au titulaire l'accès aux données (Consommations, profils, techniques et contractuelles) en votre nom.
                    Une fois votre demande soumise, le titulaire recevra un email et un SMS de notre part pour valider l'accès aux données, puis un second de la part de GRDF. La confirmation de ce consentement est obligatoire pour que l'accès soit effectif et constitue une condition préalable à toute demande de données auprès de GRDF.
                </div>

                <div
                    *ngIf="accessRightFormGroup.get('consentMethod')?.value === 'FILE'"
                    class="label-info">
                    Vous {{loggedUser?.firstname}} {{loggedUser?.lastname}} certifiez que le titulaire vous autorise à valider l'accès aux données (Consommations, profils, techniques et contractuelles) en son nom et qu'il renonce à la possibilité de pouvoir révoquer l'accès de façon autonome. 
                    <div class="mb-3">Vous autorisez Consometer - ENERGIES DEMAIN à accéder aux mêmes données en votre nom.</div>
                </div>
            </div>
        </div>

        <div class="col-sm-6 col-lg-6">
            <div
                class="panel-row"
                *ngIf="accessRightFormGroup.get('consentMethod')?.value === 'FILE'">
                <label for="fileProof" required>Preuve de la récupération du consentement</label>
                <ed-input-file
                    innerId="fileProof"
                    [allowedFormat]="['PDF', 'PNG', 'JPG', 'JPEG']"
                    [file]="accessRightFormGroup.get('fileProof')?.value ?? undefined"
                    required="true"
                    (onSubmit)="onFileUpload($event)">
                </ed-input-file>
            </div>
        </div>
    </div>

</div>

<div class="layer-actions">
    <ed-button [colorSchema]="buttonColors.Secondary" (click)="close()">Retour</ed-button>
    <ed-button (click)="valid()" [disabled]="canCreateEdit()">Ajouter le droit d'accès</ed-button>
</div>
